import { askCruzAiLogs, toggleHideAiLog } from './askCruzAi'
import { carsforsaleImportLogs } from './carsforsale'
import { dataoneImportLogs } from './dataone'
import { getErrors } from './error'
import { vdpViews } from './vdpViews'
import { vehicleSearchLogs } from './vehicleSearch'

export const logApi = {
  getErrors,
  dataoneImportLogs,
  carsforsaleImportLogs,
  vehicleSearchLogs,
  vdpViews,
  askCruzAiLogs,
  toggleHideAiLog,
}
